import Link from 'next/link';
import { Trans, useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { ScVipUserCard } from './styled';

export const VipUserCard = () => {
  const { t } = useTranslation('vip');
  return (
    <ScVipUserCard>
      <ImageComponent
        alt="crown-benefits"
        height={40}
        src="/vip/crown-benefits.webp"
        width={40}
      />
      <span className="title">{t('steps.vipTransfer.vipUser.title')}</span>
      <span className="description">
        <Trans
          components={{
            l: <Link className="link" href="/loyalty" />,
          }}
          i18nKey={'steps.vipTransfer.vipUser.description'}
          t={t}
        />
      </span>
    </ScVipUserCard>
  );
};
